import { Environment } from "./environment.model";

export const environment: Environment = {
  production: false,
  name: 'development',
  service_1: 'https://www.pruebas-costos-integrales.unidadacin.co/backend/api/v1/',
  domain: 'https://www.pruebas-costos-integrales.unidadacin.co',
  google_client_id: '405758850016-qu40u3jf966rjkt5jchti1olgnqr3rnd.apps.googleusercontent.com'
};
